/**
 * LOCATION-column cell — MapPin + location tag chip, muted em-dash when untagged (#999 Story 3.4).
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { colors } from '../../theme/colors';
import { spacing } from '../../theme/spacing';
import { MapPin } from '../icons';

export interface LocationRoomCellProps {
  locationTagName?: string | null;
  compact?: boolean;
  testID?: string;
}

export const LocationRoomCell: React.FC<LocationRoomCellProps> = ({
  locationTagName,
  compact = false,
  testID,
}) => {
  const name = locationTagName?.trim();

  if (!name) {
    return (
      <Text
        testID={testID}
        style={[styles.empty, compact && styles.emptyCompact]}
      >
        —
      </Text>
    );
  }

  return (
    <View style={styles.chip} testID={testID}>
      <MapPin
        size={compact ? 11 : 12}
        color={colors.textSecondary}
        style={styles.icon}
      />
      <Text
        style={[styles.chipText, compact && styles.chipTextCompact]}
        numberOfLines={1}
      >
        {name}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    minWidth: 0,
    gap: spacing.xs,
    paddingVertical: 4,
    paddingHorizontal: spacing.sm,
    borderRadius: 6,
    backgroundColor: colors.backgroundMuted,
  },
  icon: {
    flexShrink: 0,
  },
  chipText: {
    flexShrink: 1,
    fontSize: 12,
    fontWeight: '500',
    color: colors.textSecondary,
  },
  chipTextCompact: {
    fontSize: 11,
  },
  empty: {
    fontSize: 14,
    color: colors.textMuted,
  },
  emptyCompact: {
    fontSize: 13,
  },
});
